<script>
/**
 * @overview 主页面 - 头部
 */
import { passwordModify } from '../components';
import defaultMan from "@/assets/images/staff_man.png";
import defaultWomen from "@/assets/images/staff_women.png";
import baseUrl from "../../utils/api";

export default {
  name: 'MainHeader',
  inject: ['reload'],
  data() {
    return {
      moveErrorMan: 'this.src="' + defaultMan + '"',
      moveErrorWomen: 'this.src="' + defaultWomen + '"',
      userInfo: ''
    };
  },
  computed: {
    user() {
      return this.$store.state.mainUser;
    }
  },
  watch: {
    user(val) {
      this.userInfo = this.user
    }
  },
  created() {
    this.userInfo = this.$store.state.mainUser;
  },
  methods: {
    preLogout() {
      this.$alert('确定退出登录？', {
        showCancelButton: true,
        type: 'warning',
      }).then(this.logout);
    },

    logout() {
      this.$token.remove();
      window.location.href = `//eeop.qinglukeji.cn/sso/logout?client_id=3&redirect_uri=${window.location.origin}&response_type=token&scope=&state=3`;
    },
    preModifyPassword() {
      passwordModify.open();
    },
  },
};
</script>

<template>
  <div class="main-header">
    <img
      class="head_url"
      :src="userInfo.headimgurl ? userInfo.headimgurl : ''"
      :onerror="userInfo.gender === 1 ? moveErrorMan : moveErrorWomen"
      alt="">
    <el-dropdown>
      <span class="el-draopdown-link">
        {{ userInfo.name }}
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          @click.native="preModifyPassword"
        >
          修改密码
        </el-dropdown-item>
        <el-dropdown-item
          @click.native="preLogout"
        >
          退出登录
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<style lang="scss" scoped>
.main-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 60px;
  position: relative;
  padding: 0 20px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .tip_span_item{
    padding-right: 2rem;
    font-size: 0.8rem;
  }
  .color_tip{
    color: red;
    font-weight: bold;
  }
  .el-dropdown {
    cursor: pointer;
    &:hover{
      span {
        color: var(--color-primary);
      }
    }
  }
  .tag {
    position: absolute;
    left: 20px;
    padding-right: 20px;
  }
  .head_url {
    width: 24px;
    height: 24px;
    display: inline-block;
    border-radius: 50%;
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Main/Header.vue